import { camelToLower } from '../../../../shared/lib/caseConverters/camelToLower'
import { ExpirationDateInTable } from '../../../License'
import { LicenseUpdatesParameterCell } from './LicenseUpdatesParameterCell'

interface Props {
	columnId: string
	value: unknown
}

export const LicenseUpdatesTableCellContent = ({ columnId, value }: Props) => {
	switch (columnId) {
		case 'state':
			return <>{camelToLower((value as string) ?? '')}</>
		case 'expirationDate':
			return <ExpirationDateInTable expirationDate={value as string} />
		case 'updateReason':
			return <>{value ?? 'N/A'}</>
		case 'parameter':
			return <LicenseUpdatesParameterCell value={value} />
		default:
			return <>{value as React.ReactNode}</>
	}
}